<template>
  <b-modal id="age-gating-modal" dialog-class="base-modal" :title="title" centered
    footer-class="mt-3" :header-class="'align-items-start p-0'" title-class="px-md-5 mx-md-4"
    hide-header-close 
    no-close-on-backdrop
    no-close-on-esc
    :hide-footer="!isConfirmShown"
    :hide-header="isDeniedShown">
    <div v-if="isConfirmShown">
        <p class="modal-message text-center m-0">This website is for adults only. You must be 18 or older to continue and access the site's content.</p>
    </div>
    <div v-if="isDeniedShown" class="text-center denied-content">
        <div class="restricted-icon">
            <RestrictedIcon :fill="webDesign && webDesign.design ? webDesign.design.main_color : '#EE5663'" />
        </div>
        <h5 class="modal-title">Access Restricted</h5>
        <p class="modal-message text-center px-md-5">This website is intended for adults aged 18 and above. Thank you for your understanding.</p>
    </div>
    
    <template #modal-footer>
        <b-button pill variant="outline-secondary" class="mx-2" @click="notAllowed">No, I'm not</b-button>
        <b-button 
            :style="{
            'background-color': webDesign && webDesign.design ? `${webDesign.design.main_color} !important` : null,
            border: webDesign && webDesign.design ? 'none !important' : null,
            color: webDesign && webDesign.design ? `${webDesign.design.button_text_color} !important` : null
            }"
            pill class="mx-2"
            @click="updateConfirmAgeSession()"
        >
            Yes, I'm 18+
        </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import RestrictedIcon from "../icons/RestrictedIcon.vue";

export default {
  name: "AgeGatingModal",
  components: {
    RestrictedIcon
  },
  data() {
    return {
      isConfirmShown: true,
      isDeniedShown: false,
      title: "Please verify your age"
    }
  },
  computed: {
    ...mapState("estore", ["webDesign"])
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("age-gating-modal");
    },
    notAllowed() {
        sessionStorage.setItem("confirmAge", '0');
        this.isConfirmShown = false;
        this.isDeniedShown = true;
        this.title = "";
    },
    async updateConfirmAgeSession() {
        sessionStorage.setItem("confirmAge", '1');
        this.closeModal();
    }
  }
}
</script>

<style lang="scss">
#age-gating-modal {
    .modal-title {
        font-size: 22px !important;
        top: 20px !important;
        font-weight: 700 !important;
    }
    .modal-message {
        font-size: 16px !important;
        font-weight: 400 !important;
        color: #68737D;
    }
    .modal-footer {
        justify-content: space-evenly;

        &>.btn {
            width: calc(50% - 0.5rem * 2);
            height: 50px;
            font-size: 16px;
        }
    }

    .denied-content {
        display: flex;
        flex-direction: column;
        gap: 24px;

        .restricted-icon {
            width: 58px;
            height: 58px;
            align-self: center;
        }
    }

    .modal-content {
        border: 0 !important;
        border-radius: 20px !important;
        padding: 46px !important;
        gap: 30px;
        box-shadow: 0px 0px 20px 0px #0000001A !important;
    }

    .modal-body {
        padding: 0px !important;
    }
}
#age-gating-modal___BV_modal_backdrop_ {
    opacity: .999 !important;
    background-color: #ff8a00 !important;
}
#age-gating-modal___BV_modal_outer_ {
    z-index: 1050 !important;
}

</style>